import { getWp } from '../../common/ApiClient';
import { PrintArticle } from '../types/PrintArticle';

export const getFilteredPrintArticles = async (
  magazineId?: number,
  excludePostIds: number[] = [],
  page: number = 1,
  per_page: number = 9
): Promise<PrintArticle[]> => {
  const basePath = '/posts';
  let queryParams = `_fields=id,title,authorName,authorLink,featured_media,link,publishDate,tagName,tagLink,tagId,readTime,magazine,imageLink,isPrint&isPrint=true&per_page=${per_page}&page=${page}`;

  if (magazineId) {
    queryParams += `&magazine=${magazineId}`;
  }

  if (excludePostIds.length > 0) {
    const excludePosts = excludePostIds.join(',');
    queryParams += `&exclude_posts=${excludePosts}`;
  }

  const query = `${basePath}?${queryParams}`;
  const { data } = await getWp<PrintArticle[]>(query);

  return data;
};
